import React from "react";

import { Element, useNode } from "@craftjs/core";
import { PageImage } from "./PageImage";
import { PageText } from "./PageText";
import { Box, Card, Image, ImageBackground, Text, Link } from "components/ui";
import { useIsMobile } from "utils/hooks/useIsMobile";

interface PageTileProps {
	imageUrl?: string;
	href?: string;
	[key: string]: any;
}

interface TileChildProps {
	children?: React.ReactNode;
	[key: string]: any;
}

export const TileDescription = ({ ...props }: TileChildProps) => {
	return (
		<Box>
			<Text fontSize={14} color="$textLight600" lineHeight={20} numberOfLines={4}>
				{props.children ?? null}
			</Text>
		</Box>
	);
};
export const TileTitle = ({ ...props }: TileChildProps) => {
	return (
		<Box>
			<Text fontSize={18} lineHeight={24}>
				{props.children ?? null}
			</Text>
		</Box>
	);
};
export const TileImage = ({ ...props }: TileChildProps) => {
	return <Box>{props.children ?? null}</Box>;
};

export const PageTile = ({ imageUrl, href, ...props }: PageTileProps) => {
	const isMobile = useIsMobile();
	const displayImageUrl = imageUrl || "https://via.assets.so/img.jpg?w=500&h=250&tc=gray&bg=white&t=Upload Image";

	return (
		<Link
			href={href || "#"}
			component={(hovered: boolean) => (
				<Card
					w={"$full"}
					bg="transparent"
					display="flex"
					flexDirection="column"
					overflow="hidden"
					shadowColor="$shadowColor"
					shadowOffset={{ width: 0, height: 2 }}
					shadowOpacity={0.1}
					shadowRadius={4}
					elevation={2}
					padding={isMobile ? 12 : 24}
					style={{
						opacity: hovered ? 0.6 : 1,
						// @ts-ignore
						transition: "opacity 0.3s ease",
					}}
				>
					<Box bg="#F5F9FC" borderRadius={6} borderWidth={1} borderColor="$neutral200">
						<Box width="$full" height={300} overflow="hidden">
							<Image
								source={displayImageUrl}
								style={{
									width: "100%",
									height: 300,
									objectFit: "cover",
									transform: hovered ? "scale(1.05)" : "scale(1)",
									// @ts-ignore
									transition: "transform 0.3s ease",
								}}
							/>
						</Box>
						<Box mb={24} padding={16} flex={1} display="flex" flexDirection="column" gap={8}>
							<Element id="author-name" is={TileTitle}>
								{/* This will be populated by the CMS with the title */}
							</Element>
							<Element id="testimonial-text" is={TileDescription}>
								{/* This will be populated by the CMS with the description */}
							</Element>
						</Box>
					</Box>
				</Card>
			)}
		/>
	);
};
